import { get_token, get_user_details } from "@/router";
import Swal from "sweetalert2";

export default {
  props: {
    event_id: {
      type: [Number, String],
      default: null,
    },
    event: {
      type: Object,
      default: null,
    },
    inline: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return ({
      current_event_id: null,
      media: [],
      selectedFiles: [],
      isLoading: false,
      isUploading: false,
      isDragging: false,
      preview_url: null,
      preview_type: null,
      can_upload_media: false,
      user_details: null,
      public_gallery: true,
      is_saving_visibility: false,
    })
  },
  watch: {
    event: {
      immediate: true,
      deep: false,
      handler(next) {
        if (!this.inline) return;
        if (!next || typeof next !== "object") return;
        this.init_inline(next);
      },
    },
    event_id: {
      immediate: true,
      handler(next) {
        if (!this.inline) return;
        if (!next) return;
        this.current_event_id = next;
      },
    },
  },
  methods: {
    init_inline(event) {
      this.user_details = get_user_details();
      this.current_event_id = event?.id ?? this.event_id;

      const role = String(this.user_details?.user_role || "").toLowerCase();
      const is_admin = role === "admin";
      const event_owner_id = event?.user?.id;
      const is_owner = String(event_owner_id) === String(this.user_details?.user_id);
      this.can_upload_media = is_admin || is_owner;
      this.public_gallery = event?.public_gallery !== false;

      this.reset();
      this.fetch_media();
    },
    open_media_gallery_modal(event = null) {
      this.user_details = get_user_details();
      this.current_event_id = event?.id ?? this.event_id;

      const role = String(this.user_details?.user_role || "").toLowerCase();
      const is_admin = role === "admin";
      const event_owner_id = event?.user?.id
      const is_owner = String(event_owner_id) === String(this.user_details?.user_id);

      this.can_upload_media = is_admin || is_owner;
      this.public_gallery = event?.public_gallery !== false;
      this.reset();
      this.fetch_media();
      if (!this.inline) {
        $("#event_media_gallery_modal").modal("show");
      }
    },
    reset() {
      this.selectedFiles.forEach((item) => {
        if (item?.preview_url) URL.revokeObjectURL(item.preview_url);
      });
      this.selectedFiles = [];
      this.isUploading = false;
      this.isDragging = false;
      this.preview_url = null;
      this.preview_type = null;
    },
    getToken() {
      return get_token();
    },
    get_media_type(fileOrItem) {
      const type = String(
        fileOrItem?.type || fileOrItem?.file?.file_type || ""
      ).toLowerCase();

      const url = String(
        fileOrItem?.file?.file_url || fileOrItem?.preview_url || ""
      ).toLowerCase();

      return (
        type.startsWith("image/") ||
        /\.(png|jpe?g|gif|webp|bmp|svg)(\?|$)/.test(url)
      ) ? "image" : (
        type.startsWith("video/") ||
        /\.(mp4|webm|ogg|mov|m4v)(\?|$)/.test(url)
      ) ? "video" : (
        type.startsWith("audio/") ||
        /\.(mp3|wav|ogg|m4a|aac)(\?|$)/.test(url)
      ) ? "audio" : "unknown";
    },
    is_supported_media(file) {
      const type = this.get_media_type(file);
      return ["image", "video", "audio"].includes(type);
    },
    trigger_file_picker() {
      this.$refs.mediaFilesInput?.click();
    },
    on_files_selected(e) {
      const files = Array.from(e?.target?.files || []);
      this.add_selected_files(files);
      if (e?.target) e.target.value = "";
    },
    on_drag_over() {
      this.isDragging = true;
    },
    on_drag_leave() {
      this.isDragging = false;
    },
    on_drop(e) {
      this.isDragging = false;
      const files = Array.from(e?.dataTransfer?.files || []);
      this.add_selected_files(files);
    },
    file_key(file) {
      return `${file?.name || "file"}-${file?.size || 0}-${file?.lastModified || 0}`;
    },
    add_selected_files(files) {
      const incoming = (files || []).filter((f) => this.is_supported_media(f));
      if (!incoming.length) return;

      const existingKeys = new Set(this.selectedFiles.map((i) => i.key));
      const next = [...this.selectedFiles];

      incoming.forEach((file) => {
        const key = this.file_key(file);
        if (existingKeys.has(key)) return;
        existingKeys.add(key);
        next.push({
          key,
          file,
          name: file.name,
          mediaType: this.get_media_type(file),
          preview_url: URL.createObjectURL(file),
        });
      });

      this.selectedFiles = next;
    },
    remove_selected_file(index) {

      const item = this.selectedFiles.at(index);
      if (item?.preview_url) URL.revokeObjectURL(item.preview_url);
      this.selectedFiles.splice(index, 1);
    },
    clear_selected_files() {
      this.selectedFiles.forEach((item) => {
        if (item?.preview_url) URL.revokeObjectURL(item.preview_url);
      });
      this.selectedFiles = [];
    },
    fetch_media() {
      const event_id = this.current_event_id ?? this.event_id;
      if (!event_id) return;

      this.isLoading = true;
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/get_event_media/`,
        type: "POST",
        headers: {
          Authorization: `Token ${this.getToken()}`,
          "Content-Type": "application/json",
        },
        data: JSON.stringify({ event_id }),
        success: (response) => {
          if (response.status !== "success") return;
          this.media= response.data
        },
        complete: () => {
          this.isLoading = false;
        },
      });
    },
    save_gallery_visibility() {
      const event_id = this.current_event_id ?? this.event_id;
      if (!event_id) return;

      const next_value = !!this.public_gallery;
      this.is_saving_visibility = true;

      const formData = new FormData();
      formData.append("event_id", event_id);
      formData.append("public_gallery", next_value ? "true" : "false");

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/toggle_event_media_visibility/`,
        type: "POST",
        headers: {
          Authorization: `Token ${this.getToken()}`,
        },
        data: formData,
        processData: false,
        contentType: false,
        success: (response) => {
          if (response.status === "success") {
            this.$emit("visibility-updated", next_value);
            Swal.fire({
              icon: "success",
              title: "Saved",
              text: "Gallery visibility updated.",
              showConfirmButton: false,
              timer: 1500,
              position: "bottom-end",
              toast: true
            });
          }
        },
        error: (xhr) => {
          this.public_gallery = !next_value;
          Swal.fire({
            icon: "error",
            title: "Update failed",
            text: xhr?.responseJSON?.message || "Failed to update gallery visibility.",
            showConfirmButton: false,
            timer: 3000,
            position: "bottom-end",
            toast: true
          });
        },
        complete: () => {
          this.is_saving_visibility = false;
        },
      });
    },
    upload_images() {
      if (!this.can_upload_media) {
        Swal.fire({
          icon: "error",
          title: "Not allowed",
          text: "Only the event creator or an admin can upload media.",
          showConfirmButton: false,
          timer: 2500,
          position: 'bottom-end',
          toast: true
        });
        return;
      }
      const event_id = this.current_event_id ?? this.event_id;
      if (!event_id) {
        Swal.fire({
          icon: "error",
          title: "Missing event",
          text: "Please select an event before uploading media.",
          timer: 2500,
          showConfirmButton: false,
          position: 'bottom-end',
          toast: true
        });
        return;
      }
      if (!this.selectedFiles.length) return;

      const formData = new FormData();
      formData.append("event_id", event_id);
      formData.append("public_gallery", this.public_gallery ? "true" : "false");
      this.selectedFiles.forEach((item) => {
        formData.append("files", item.file);
      });

      this.isUploading = true;
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/upload_event_media/`,
        type: "POST",
        headers: {
          Authorization: `Token ${this.getToken()}`,
        },
        data: formData,
        processData: false,
        contentType: false,
        success: (response) => {
          if (response.status === "success") {
            Swal.fire({
              icon: "success",
              title: "Uploaded",
              text: response.message || "Media uploaded successfully.",
              showConfirmButton: false,
              timer: 1500,
              position: 'bottom-end',
              toast: true
            }).then(() => {
              this.clear_selected_files();
              this.media.unshift(...response.data);
              this.$emit('media-updated', response.data);
              this.$emit("visibility-updated", this.public_gallery);
            });
          }
        },
        error: (xhr) => {
          Swal.fire({
            icon: "error",
            title: "Upload failed",
            text: xhr?.responseJSON?.message || "Failed to upload media.",
            showConfirmButton: false,
            timer: 3000,
            position: 'bottom-end',
            toast: true
          });
        },
        complete: () => {
          this.isUploading = false;
        },
      });
    },
    open_preview(item) {
      this.preview_url = item?.file?.file_url || item?.preview_url || null;
      this.preview_type = this.get_media_type(item);
      $("#event_media_preview_modal").modal("show");
      $("#event_media_gallery_modal").modal("hide");
    },
    close_preview() {
      this.preview_url = null;
      this.preview_type = null;
      $("#event_media_preview_modal").modal("hide");
      $("#event_media_gallery_modal").modal("show");
    },
    delete_image(item) {
      if (!this.can_upload_media) {
        Swal.fire({
          icon: "error",
          title: "Not allowed",
          text: "Only the event creator or an admin can delete media.",
          showConfirmButton: false,
          timer: 2500,
          position: 'bottom-end',
          toast: true
        });
        return;
      }
      const event_media_id = item?.id;
      if (!event_media_id) return;

      Swal.fire({
        title: "Delete image?",
        text: "This action cannot be undone.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete",
        position: 'bottom-end',
        toast: true
      }).then((result) => {
        if (!result.isConfirmed) return;

        $.ajax({
          url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/delete_event_media/`,
          type: "POST",
          headers: {
            Authorization: `Token ${this.getToken()}`,
            "Content-Type": "application/json",
          },
          data: JSON.stringify({event_file_id: event_media_id }),
          success: (response) => {
            if (response.status === "success") {
              this.media = this.media.filter((m) => String(m.id) !== String(event_media_id));
              this.$emit('media-deleted', event_media_id);
              Swal.fire({
                icon: "success",
                title: "Deleted",
                showConfirmButton: false,
                timer: 1200,
                position: 'bottom-end',
                toast: true
              });
            }
          },
          error: (xhr) => {
            Swal.fire({
              icon: "error",
              title: "Delete failed",
              text: xhr?.responseJSON?.message || "Failed to delete image.",
              showConfirmButton: false,
              timer: 3000,
              position: 'bottom-end',
              toast: true
            });
          },
        });
      });
    },
    toggle_pin (item){
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/pin_event_media/`,
        type: "POST",
        headers: {
          Authorization: `Token ${this.getToken()}`,
          "Content-Type": "application/json",
        },
        data: JSON.stringify({event_file_id: item.id, is_pinned: !item.is_pinned }),
        success: (response) => {
          if (response.status === "success") {
            const index = this.media.findIndex(m => m.id === item.id);
            if (index !== -1) {
                const newStatus = !item.is_pinned;
                item.is_pinned = newStatus;
                const [movedItem] = this.media.splice(index, 1);
                if (newStatus) {
                    this.media.unshift(movedItem);
                } else {
                    this.media.push(movedItem);
                }
                this.$emit('pin-changed', { id: item.id, is_pinned: newStatus, event_id: this.event_id });
            }
          }
        },
        error: (xhr) => {
          Swal.fire({
            icon: "error",
            title: "Pin failed",
            text: xhr?.responseJSON?.message || "Failed to pin image.",
            showConfirmButton: false,
            timer: 3000,
            position: 'bottom-end',
            toast: true
          });
        },
      });

    }
  },
};
